import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';

import { useStores } from 'src/components/common/root-store-provider/root-store-provider';
import SelectOption, {
  OptionVariants,
} from 'src/components/main/quiz/select-option/select-option';
import { Policy } from 'src/widgets/policy';

import { fbAnalytics } from '@features/Analytics';
import { tikTokEvent } from '@features/Analytics/services/tik-tok-pixel';

import ImproveRelationships from '../../../../assets/images/quiz/improve-relationships.svg';
import PerfectMatch from '../../../../assets/images/quiz/perfect-match.svg';
import { Image } from '../../../common/Image';
import styles from './welcome-screen-ab-test.module.scss';

const BUTTONS_TEXT = [
  {
    value: 0,
    label: (
      <>
        Find my perfect match{' '}
        <Image src="arrow-right.svg" alt="arrow" width={14} height={14} />
      </>
    ),
    image: PerfectMatch,
  },
  {
    value: 1,
    label: (
      <>
        Improve my relationships{' '}
        <Image src="arrow-right.svg" alt="arrow" width={14} height={14} />
      </>
    ),
    image: ImproveRelationships,
  },
];

const STARS = Array.from({ length: 10 }, (_, index) => (
  <span key={index} className={styles.star}></span>
));
export const WelcomeScreenABTest = observer(
  ({ onChange }: { onChange: (value: number) => void }) => {
    // @ts-ignore
    const fbLoaded = window.fbq !== undefined;
    // @ts-ignore
    const tikTokLoaded = window.ttq !== undefined;

    const {
      quizStore: { welcome, setWelcome },
    } = useStores();
    const handleClick = useCallback(
      (value: number) => {
        setWelcome(value);
        onChange(value);
      },
      [onChange, setWelcome],
    );

    useEffect(() => {
      if (fbLoaded) {
        fbAnalytics({
          eventName: 'ViewContent',
          postPath: 'event_start_onboard',
        });
      }
    }, [fbLoaded]);

    useEffect(() => {
      if (tikTokLoaded) {
        tikTokEvent('ViewContent');
      }
    }, [tikTokLoaded]);
    return (
      <div className={styles.container}>
        <header>
          <Image src="logo.webp" width={40} height={40} alt="logo" priority />
          <div>
            <h3>Eclipse</h3>
            <p>Personal moon phases calendar</p>
          </div>
        </header>
        <section className={styles.mainSection}>
          <p className={styles.title}>Remove loneliness and bad patterns </p>
          <h3 className={styles.subtitle}>
            Get <b className={styles.subtitleBold}>compatibility guidance</b>
          </h3>
          <h3 className={styles.text}>Take a quick quiz</h3>
          <div className={styles.optionsContainer}>
            {BUTTONS_TEXT.map(({ value: anotherValue, label, image }) => (
              <SelectOption
                key={`welcome_screen_ab_test_${anotherValue}`}
                onChange={() => handleClick(anotherValue)}
                optionVariant={
                  welcome != null && anotherValue === welcome
                    ? OptionVariants.OptionSelected
                    : welcome == null
                      ? OptionVariants.default
                      : OptionVariants.OptionNotSelected
                }
                optionShapeType="withImage"
                image={image}
                label={label}
              />
            ))}
          </div>
        </section>
        <footer>
          <Policy className={styles.policy} place="burger_menu" />
        </footer>
        <section>{STARS}</section>
      </div>
    );
  },
);
